import React from "react";
import "./Services.css"; // Updated to match correct filename

const services = [
  {
    title: "Web Development",
    description:
      "Full-stack web development using modern technologies like React, Node.js, and Next.js.",
  },
  {
    title: "Mobile App Development",
    description:
      "Cross-platform mobile applications for iOS and Android using React Native and Flutter.",
  },
  {
    title: "UI/UX Design",
    description:
      "User-centered designs that enhance usability and deliver aesthetic digital experiences.",
  },
  {
    title: "E-commerce Solutions",
    description:
      "Custom Shopify and WooCommerce stores tailored for online success.",
  },
  {
    title: "Backend Development",
    description:
      "Scalable and secure APIs and server-side logic using Node.js, Express, and PHP.",
  },
  {
    title: "Graphic Design",
    description:
      "Branding, marketing material, and custom illustrations to elevate your brand.",
  },
];

const Services = () => {
  return (
    <section className="services-section">
      <div className="services-container">
        <h1 className="services-title">Our Services</h1>
        <p className="services-subtitle">What We Offer at StarlinkLab</p>
        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
